import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { GetDeterminePlanFlow } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const DeterminePlanFlow = createAsyncThunk('get/determinePlanFlow', GetDeterminePlanFlow);

export const DeterminePlanFlowSlice = createSlice({
	name: 'determinePlanFlow',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[DeterminePlanFlow.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[DeterminePlanFlow.rejected.toString()]: setAPIError,
		[DeterminePlanFlow.fulfilled.toString()]: (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION<any>) => {
			const { payload } = action;
			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = payload;
		},
	},
});

interface IStates {
	[DeterminePlanFlowSlice.name]: ReturnType<typeof DeterminePlanFlowSlice.reducer>;
}

export const determinePlanFlowSelector = (state: IStates): any => {
	return state[DeterminePlanFlowSlice.name] || {};
};

export const useDeterminePlanFlow = (): any => useSelector(determinePlanFlowSelector);

export const getDeterminePlanFlow =
	(params: any) =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(DeterminePlanFlow(params));
		return;
	};

export const resetDeterminePlanFlow =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(DeterminePlanFlowSlice.actions.RESET());
		return;
	};
